import { ReactNode } from "react";
import { View } from "react-native";

const CommentKeyboardAvoidingWrapper = ({ children }: { children?: ReactNode }) => {
	return (
		<View
			style={{
				flex: 1,
			}}
		>
			{children}
		</View>
	);
};
export default CommentKeyboardAvoidingWrapper;
